import React from 'react';
import Rotas from './routes';
import { ToastContainer } from 'react-toastify';

const App = () => <Rotas />;
export default App;
